import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import {
	Button,
	FontIconName,
	IconButton
} from "client/Components";
import { MeetingProductKind } from "client/Api/Notifications/notifications";
import { navigateTo } from "client_legacy/ndaw/navigator";

export type OnlineMeetingButtonProps = {
	product: MeetingProductKind;
	url: string;
	trackingId?: string;
	hasOnlyIcon?: boolean;
};

export const OnlineMeetingButton = (props: OnlineMeetingButtonProps): ReactElement => {
	const {
		product,
		url,
		trackingId,
		hasOnlyIcon = false,
	} = props;

	const onClick = (): void => {
		navigateTo(url, true);
	};

	return hasOnlyIcon ?
		(
			<IconButton
				kind="secondary"
				icon={productToIconMap[product]}
				onClick={onClick}
				trackingId={trackingId}
				bubbleClick={false}
			/>
		)
		: (
			<Button
				kind="secondary"
				text={localize("_Join")}
				icon={productToIconMap[product]}
				onClick={onClick}
				trackingId={trackingId}
				bubbleClick={false}
			/>
		);
};

OnlineMeetingButton.displayName = "OnlineMeetingButton";

export const productToIconMap: { [key in MeetingProductKind]: FontIconName } = {
	[MeetingProductKind.Teams]: "ms-teams",
	[MeetingProductKind.JoinMe]: "join-me",
	[MeetingProductKind.Zoom]: "zoom",
};
